import { NgForm } from '@angular/forms';

export class FormUtils {
    static markFormAsPristine (form?: NgForm): void {
        form?.form?.markAsPristine();
    }
    static markFormAsDirty (form?: NgForm): void {
        form?.form?.markAsDirty();
    }
    static markAllControlsAsTouched (form?: NgForm): void {
        if (form && form.form) {
            Object.keys(form.form.controls).forEach((controlName) => {
                const control = form.form.get(controlName);
                if (control) {
                    control.markAsTouched();
                }
            });
        }
    }
}
